export default __webpack_public_path__ + "static/media/scope-discount-subscription-v3.c41363f9.png";